/*@ngInject*/
const UISystemFontDirective = function (coreMediator, preferenceModel, coreConstant) {

    let linkFunction = function ($scope, $elm, $attrs) {
        $scope.$on(coreConstant.event.APPLICATION_READY, function () {
            coreMediator.loadUserPreferences().then(function () {
                if (preferenceModel.get('system.useApplicationFontInHTMLFormsViewer')) {
                    $elm.addClass('enableOldFont');
                } else {
                    $elm.removeClass('enableOldFont');
                }
            });
        });
    };

    return {
        restrict: 'A',
        link: linkFunction
    };
};

angular.module('umCore')
    .directive('uiSystemFont', UISystemFontDirective);
